import { render, staticRenderFns } from "./PurchaseOrderDetailDialog.vue?vue&type=template&id=520c5dd0&scoped=true"
import script from "./PurchaseOrderDetailDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520c5dd0",
  null
  
)

export default component.exports